<template>
  <div id="app">
    <preloader v-show="loading"></preloader>
    <modal v-if="modal"></modal>
    <router-view />
  </div>
</template>

<script>
import i18n from "./i18n";
import { mapActions, mapState } from "vuex";
import Modal from "@/components/Modal";
import Preloader from "@/components/Preloader";

export default {
  components: {
    Preloader,
    Modal
  },
  computed: {
    ...mapState("common", ["loading", "modal"])
  },
  methods: {
    ...mapActions("auth", ["setUser"])
  },
  async mounted() {
    i18n.locale = localStorage.getItem("locale");
    const user = localStorage.getItem("user");
    if (user) {
      this.setUser(user);
    }
  }
};
</script>

<style lang="scss">
@import "~normalize.css/normalize.css";
@import "assets/styles/style";
</style>
